// extracted by mini-css-extract-plugin
module.exports = {"root":"PlanDiscountStatusCard_root___0QHT","anchorMark":"PlanDiscountStatusCard_anchorMark__e7RWp","display":"PlanDiscountStatusCard_display__TZX_A"};